export default ".img {\n  vertical-align: middle;\n}";